var map = {
	"./h1.webp": 190,
	"./h2.webp": 215,
	"./h3.webp": 204,
	"./h4.webp": 997,
	"./h5.webp": 498,
	"./h6.webp": 347,
	"./h7.webp": 515,
	"./h8.webp": 753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 229;